import api from '@/rest-api'

export default {
    register(data) {
        return api.post(`/partner/register`, data)
    }
}